import { type userType } from '../common-types';

export interface KnowledgeCardUserSearchVariables {
	userQuery: string;
	siteId: string;
}

export interface KnowledgeCardSearchUserType {
	name: string;
	id: string;
	avatarUrl: string | null;
	title: string | null;
}

export interface KnowledgeCardUserSearchQueryType {
	knowledgeDiscovery: {
		searchUser: {
			users?: [KnowledgeCardSearchUserType];
			message?: string | null;
		};
	};
}

export const KNOWLEDGE_CARD_USER_SEARCH_OPERATION_NAME = 'KnowledgeCardUserSearchQuery';
export const KnowledgeCardUserSearchQuery = `
query ${KNOWLEDGE_CARD_USER_SEARCH_OPERATION_NAME}($userQuery: String!, $siteId: String!) {
  knowledgeDiscovery {
   	searchUser (
        userQuery: $userQuery
        siteId: $siteId
    ) @optIn(to: "KnowledgeDiscovery Search User"){
      ... on KnowledgeDiscoveryUsers {
        users {
            name
            id
            avatarUrl
            title
        }
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;

export interface recommendedUserType {
	id: string;
	user: userType;
}

export interface KnowledgeCardPrimaryUserDataQueryType {
	user: {
		id: string;
		picture: string;
		name: string;
		accountStatus: string;
		email?: string | null;
		zoneinfo?: string | null;
		extendedProfile?: {
			jobTitle?: string | null;
			department?: string | null;
			location?: string | null;
			organization?: string | null;
		};
	};
	smarts: {
		recommendedUser: recommendedUserType[];
	};
}

export interface KnowledgeCardPrimaryUserDataVariables {
	accountId: string;
	accountIdARI: string;
	tenantId: string;
	requestingUserId: string;
}

export const KNOWLEDGE_CARD_PRIMARY_USER_OPERATION_NAME = 'KnowledgeCardPrimaryUserDataQuery';
// we construct accountIdARI by appending "ari:cloud:identity::user/" + accountId
export const KnowledgeCardPrimaryUserDataQuery = `
    query ${KNOWLEDGE_CARD_PRIMARY_USER_OPERATION_NAME}(
        $accountId: String!
        $accountIdARI: ID!
        $tenantId: String!
        $requestingUserId: String!
        ) {
        user(accountId: $accountIdARI) {
            id
            picture
            name
            accountStatus
            ... on AtlassianAccountUser {
                email
                zoneinfo
                extendedProfile {
                    jobTitle
                    department
                    organization
                    location
                }
            }
        }
        smarts {
            recommendedUser(recommendationsQuery: {
            context: {
                userId: $accountId, tenantId: $tenantId
            },
            modelRequestParams: {
                caller: "search-ai",
                experience: "CgUserNearbyUser"
            },
            requestingUserId: $requestingUserId,
            maxNumberOfResults: 8
            }
            ) {
            id
            user {
                id
                picture
                name
                accountStatus
                ... on AtlassianAccountUser {
                email
                extendedProfile {
                    jobTitle
                    department
                }
                }
            }
            }
        }
    }
`;
